import { pricing } from '@/pages/unauthenticated/pricing/components/constants';
import { cn } from '@/lib/utils';

import { TierCardBackground } from './tier.card-background';
import { TierCardBorder } from './tier.card-border';
import { TierGridCells } from './tier.grid-cells';
import { TierHeader } from './tier.header';

export const TierComparisonMobile = () => {
  return (
    <section aria-labelledby="mobile-comparison-heading" className="lg:hidden">
      <h2 id="mobile-comparison-heading" className="sr-only">
        Feature comparison
      </h2>

      <div className="mx-auto max-w-2xl space-y-16">
        {pricing.tiers.map((tier, index) => (
          <div
            key={tier.activeTier}
            className={cn('border-t border-border', {
              'border-none': index === 0,
            })}
          >
            <TierHeader tier={tier} />

            <div className="mt-10 space-y-10">
              {pricing.sections.map((section) => (
                <div key={section.name}>
                  <h4 className="text-sm font-semibold leading-6">
                    {section.name}
                  </h4>
                  <div className="relative mt-6">
                    <TierCardBackground />

                    <div
                      className={cn(
                        'relative rounded-lg bg-halfmast-1100/80 shadow-xs sm:rounded-none sm:bg-transparent sm:shadow-none sm:ring-0 ring-1 ring-halfmast-900/10',
                        {
                          'ring-2 ring-primary': tier.featured,
                        },
                      )}
                    >
                      <dl className="divide-y divide-border text-sm leading-6">
                        {section.features.map((feature) => (
                          <div
                            key={feature.name}
                            className="flex items-center justify-between px-4 py-3 sm:grid sm:grid-cols-2 sm:px-0"
                          >
                            <TierGridCells
                              tiers={pricing.tiers}
                              tier={tier}
                              feature={feature}
                            />
                          </div>
                        ))}
                      </dl>
                    </div>

                    <TierCardBorder isFeatured={tier.featured} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
